import PT from "prop-types";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import StoryHeader from "../story-header";
import useStorage from "../../../hook/useStorage";
import { Suurtaulu } from "../../atoms/suurtaulu";
import { Readpeak } from "../../atoms/readpeak";
import { SocialShare, StoryElement } from "@quintype/components";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import StoryPaywallComponent from '../../atoms/paywalls/story-paywall-component';
import SideBar from "../../molecules/sidebar";

import "./video.m.css";

function getPrimaryVideo(cards) {
  const headerVideo = [];
  cards.forEach(function (card) {
    card["story-elements"].forEach(function (element) {
      if (element.type === "youtube-video" || element.type === "jsembed" || element.subtype === "dailymotion-video") {
        headerVideo.push(element);
      }
    });
  });
  return headerVideo[0];
}
function getCards(story, primaryVideoID) {
  const storyCards = story.cards.map(card => {
    const newCard = Object.assign({}, card);
    const elements = card["story-elements"].filter(element => element.id !== primaryVideoID);
    newCard["story-elements"] = elements;
    return newCard;
  });
  story.cards = storyCards;
  return story;
}

const VideoStory = ({ story }) => {

  story = Object.assign({}, story);
  const primaryVideo = getPrimaryVideo(story.cards);
  const [imgId, setImgId] = useState();
  const splitUrl = primaryVideo["embed-url"] && primaryVideo["embed-url"].split("/") || [];
  const youtubeId = splitUrl[splitUrl.length - 1];

  useEffect(() => {
    if (typeof window === "undefined") {
      return null;
    } else {
      if (primaryVideo.type === "jsembed") {
        const decodedHTML = window.atob(primaryVideo["embed-js"]);
        const extractId = decodedHTML.substring(decodedHTML.indexOf("id=") + 3, decodedHTML.lastIndexOf("&"));
        setImgId(extractId);
      }
    }
  }, [])
  const primaryVideoType = primaryVideo.type;
  const storyProps = primaryVideo ? getCards(story, primaryVideo.id) : story;
  const arrayWithStoryElements = get(storyProps, ["cards"], ["story-elements"] || []);
  const arrayWithTexts = arrayWithStoryElements && arrayWithStoryElements.filter((textedObj) => textedObj["story-elements"].length > 0 || "")

  const allText = arrayWithTexts[0] && arrayWithTexts[0]["story-elements"][0] || "";
  const text = allText.text&&(allText.text.length>=280?
                allText.text.slice(0,280).concat(`<span>...</span>`):
                allText.text.slice(0,allText.text.length-1).concat(`<span>...</span>`));
  const customTemplate = ({element}) => <p dangerouslySetInnerHTML={{ __html: text }}/>;

  const [checkUser, activeProducts, whiteListed,visitCounts,articlesLimit] = useStorage();
  const metakeywords = story["seo"]["meta-keywords"];
  const hashtags = metakeywords ? metakeywords.map(item => {
    return item.replace(/ /g, "");
  }) : "";

  const storySections = story.sections;
  var section;
  var slug;

  if (storySections.find(section => section["domain-slug"] === "ilkka-pohjalainen")){
    section = storySections.find(section => section["domain-slug"] === "ilkka-pohjalainen");
  }

  else if (storySections.find(section => section["domain-slug"] !== "undefined")) {
    section = story.sections[0];
  }

  if (section.collection === undefined) {
    slug = "";
  }// else {
   // slug = section.collection.slug;
 // }


  return (
    <React.Fragment>
      <div styleName="top-container">
        <div styleName="main-container">
          <div styleName="main">
            <div styleName="ad-container">
              <div styleName="mob-ad">
                <div id="sas_63333" data-placement-id="paraatipaikka-mobile"></div>
              </div>
              <div styleName="dsktop-ad">
                <div id="sas_63219" data-placement-id="paraatipaikka-desktop"></div>
              </div>
            </div>
            <div styleName="ad-container">
              <div styleName="mob-ad">
                <div id="sas_112313" data-placement-id="paraatipaikka-2-mobile"></div>
              </div>
              <div styleName="dsktop-ad">
                <div id="sas_112312" data-placement-id="paraatipaikka-2-desktop"></div>
              </div>
            </div>
          </div>
          <div styleName="blank-story">
            <div styleName="sticky-social-share">
              <SocialShare
                template={StickySocialShareTemplate}
                story={story}
                title={story.headline}
                url={story.slug}
                hashtags={story["seo"]["meta-keywords"] ? hashtags.join(",") : ""}
                color="#000"
                sticky
              />
            </div>
            <div className="voice-article" styleName="story-container">
              <div styleName="story-header">
                <StoryHeader story={story} isHeroImage={false} />
                {(primaryVideoType !== "youtube-video") ?
                  ((!checkUser || (checkUser && !activeProducts)) ?
                    (!whiteListed ? (<div styleName="img-outer">
                      <img src={`https://cff1aefc0.lwcdn.com/i/v-i-${imgId}-1.jpg`} />
                      <div styleName="btn">
                        <img src="/assetify/video.svg" alt="video" />
                      </div>
                      </div>) :
                      <StoryElement element={primaryVideo} story={story} />) :
                    <StoryElement element={primaryVideo} story={story} />) :
                  ((!checkUser || (checkUser && !activeProducts)) ?
                    ((!whiteListed ? (<div styleName="img-outer">
                      <img width="100%" height="400vh" src={`https://img.youtube.com/vi/${youtubeId}/0.jpg`} />
                      <div styleName="btn-youtube">
                        <img src="/assetify/video.svg" alt="video" />
                      </div>
                      </div>) :
                      (<iframe width="100%" height="400vh"
                        src={primaryVideo["embed-url"]}>
                      </iframe>))) :
                    (<iframe width="100%" height="400vh"
                      src={primaryVideo["embed-url"]}>
                    </iframe>))}
              </div>
              {<StoryPaywallComponent story={storyProps} showAds={true} allTextVideo={allText} customTemplateVideo={customTemplate}/>}
              <div styleName="readpeak-widget">
                <Readpeak />
              </div>
            </div>
            <SideBar useCollection={slug}/>
          </div>
        </div>
        <Suurtaulu />
      </div>
    </React.Fragment>
  );
}
VideoStory.propTypes = {
  story: PT.object
};
export { VideoStory };
